import React from 'react'
import useFeatureFlags from 'hooks/useFeatureFlags'
import { EMARMedicationStockScreen } from './EMARMedicationStockScreen'
import { EMARMedicationStockScreenV2 } from '../ResidentEmarV2Screens/EMARMedicationStockScreenV2'

const EMARMedicationStockScreenWrapper: React.FC = () => {
  const flags = useFeatureFlags({ flagNames: ['new_emar'] })?.data

  const newEmarEnabled = flags?.new_emar?.enabled ?? false

  if (newEmarEnabled) {
    return <EMARMedicationStockScreenV2 />
  }

  return <EMARMedicationStockScreen />
}

export default EMARMedicationStockScreenWrapper
